import React from "react";
import AboutUs from "./AboutUs";

const OfferSection = () => {
  return (
    <>
      <div className="w-full bg-white">
        <div className="container max-w-[1240px] mx-auto w-full h-[400px]">
          <div className="w-[1240px] h-[357px] bg-[#FEFEFE] rounded-[10px] pt-[32px] pl-[45px] pb-[50px] pr-[53px] flex flex-col gap-y-[28px] border">
            <h3 className="w-[182px] h-[30px] text-start text-black font-semibold text-[18px]">
              What do we offer ?
            </h3>
            <div className="flex flex-row w-full gap-x-[47px]">
              <div className="w-[191px] h-[217px] border rounded-[10px] flex flex-col items-center justify-center gap-y-[26px] bg-white">
                <p className="w-[84px] h-[84px] rounded-full bg-[#F0FFE9] flex items-center justify-center">
                  <img
                    src={require("../../assets/WebFront/Offer/Assurance.jpg")}
                    alt=""
                    className="w-[52px] h-[52px]"
                  />
                </p>
                <p className="w-[127px] h-[48px] text-center font-semibold text-[16px] text-black">
                  Trade Assurance
                </p>
              </div>

              <div className="w-[191px] h-[217px] border rounded-[10px] flex flex-col items-center justify-center gap-y-[26px] bg-white">
                <p className="w-[84px] h-[84px] rounded-full bg-[#F0FFE9] flex items-center justify-center">
                  <img
                    src={require("../../assets/WebFront/Offer/Smooth.jpg")}
                    alt=""
                    className="w-[48px] h-[48px]"
                  />
                </p>
                <p className="w-[147px] h-[48px] text-center font-semibold text-[16px] text-black">
                  Smooth Operations
                </p>
              </div>

              <div className="w-[191px] h-[217px] border rounded-[10px] flex flex-col items-center justify-center gap-y-[26px] bg-white">
                <p className="w-[84px] h-[84px] rounded-full bg-[#F0FFE9] flex items-center justify-center">
                  <img
                    src={require("../../assets/WebFront/Offer/NationWide.jpg")}
                    alt=""
                    className="w-[40px] h-[37px]"
                  />
                </p>
                <p className="w-[143px] h-[48px] text-center font-semibold text-[16px] text-black">
                  Nationwide Access
                </p>
              </div>

              <div className="w-[191px] h-[217px] border rounded-[10px] flex flex-col items-center justify-center gap-y-[26px] bg-white">
                <p className="w-[84px] h-[84px] rounded-full bg-[#F0FFE9] flex items-center justify-center">
                  <img
                    src={require("../../assets/WebFront/Offer/Logistics.jpg")}
                    alt=""
                    className="w-[50px] h-[54px]"
                  />
                </p>
                <p className="w-[166px] h-[48px] text-center font-semibold text-[16px] text-black">
                  Digitalize Logistics Support
                </p>
              </div>

              <div className="w-[191px] h-[217px] border rounded-[10px] flex flex-col items-center justify-center gap-y-[26px] bg-white">
                <p className="w-[84px] h-[84px] rounded-full bg-[#F0FFE9] flex items-center justify-center">
                  <img
                    src={require("../../assets/WebFront/Offer/Inspection.jpg")}
                    alt=""
                    className="w-[49px] h-[49px]"
                  />
                </p>
                <p className="w-[142px] h-[48px] text-center font-semibold text-[16px] text-black">
                  Product Inspection
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <AboutUs /> */}
    </>
  );
};

export default OfferSection;
